module.exports = __webpack_public_path__ + "static/media/vas.36cf23a1.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/img/icons/vas.svg
 ** module id = 188
 ** module chunks = 0
 **/